import { atom } from 'jotai';

export const taskPatientSearchTextAtom = atom('');
